<style scoped>
.cover-shape {
  position: absolute;
  left: 0;
  bottom: 0px;
  width: 100%;
  height: 10%;
  background-image: linear-gradient(
    90deg,
    rgb(255, 129, 103),
    rgb(235, 94, 65)
  );
}
.signin-form {
  min-width: 250px;
  max-width: 350px;
}
.signin-form img {
  width: 100%;
  height: 80px;
  object-fit: contain;
}
.cover-shape img {
  /* svg on an img tag */
  transform: rotate(180deg);
  width: 100%;
  position: absolute;
  top: -1px;
  left: 0px;
}
</style>
<template>
  <div class="fill-height">
    <div class="cover-shape">
      <img src="/img/accents/img.svg" />
    </div>
    <v-app-bar
      :clipped-left="primaryDrawer.clipped"
      app
      color="white"
      elevation="0"
      class="outlined"
    >
      <v-toolbar-title>
        <v-img
          src="https://images.static.arist.co/5d1315c147dda60e60b6d7b1/1567567119748_102585"
          max-height="50"
          contain
          position="left"
        ></v-img>
      </v-toolbar-title>
      <v-spacer />
    </v-app-bar>
    <v-container fluid class="fill-height">
      <v-row>
        <v-col cols="12">
          <v-row
            align="center"
            justify="center"
            class="grey lighten-5"
            style="height: 100%"
          >
            <!-- <v-card class="ma-3 pa-6" outlined> </v-card> -->
            <v-card width="100%" max-width="400px" class="ma-3" flat outlined>
              <v-window v-model="step">
                <v-window-item :value="1" class="pa-4">
                  <a-signin @signup="step = 2" :key="step" @success="onSuccess"
                /></v-window-item>
                <v-window-item :value="2" class="pa-4">
                  <a-signup @signin="step = 1" :key="step" @success="onSuccess"
                /></v-window-item>
              </v-window>
            </v-card>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<style scoped>
.outlined {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}
</style>
<script>
import signInComponent from "@/components/signin";
import signUpComponent from "@/components/signup";
export default {
  components: {
    "a-signin": signInComponent,
    "a-signup": signUpComponent
  },
  data() {
    return {
      step: 1,
      primaryDrawer: {
        model: null,
        clipped: true,
        floating: false,
        mini: false
      },
      alignmentsAvailable: ["start", "center", "end", "baseline", "stretch"],
      alignment: "center",
      dense: false,
      justifyAvailable: [
        "start",
        "center",
        "end",
        "space-around",
        "space-between"
      ],
      justify: "center"
    };
  },
  methods: {
    onSuccess() {
      try {
        this.$ga.event({
          eventCategory: "dashboard-account",
          eventAction: "signin-generic",
          eventLabel: "Dashboard"
        });
      } catch (err) {
        console.log(err);
      }
      this.$router.push({ name: "dashboard" });
    }
  }
};
</script>
<style></style>
